<template>
  <v-col
    cols="3"
    class="sidebar-filter"
  >
    <v-row
      no-gutters
      align="center"
    >
      <v-col>
        <v-subheader
          :class="{ 'primary--text font-weight-bold': emphasized, 'text--secondary': !emphasized }"
          class="caption"
        >
          {{ title }}
        </v-subheader>
      </v-col>
      <v-col
        v-if="filtersActive"
        cols="auto"
      >
        <v-btn
          color="red"
          text
          small
          class="text-none"
          @click="$emit('filters:clear-all')"
        >
          <v-icon
            left
            x-small
          >
            fas fa-times
          </v-icon>
          Clear All
        </v-btn>
      </v-col>
    </v-row>
    <v-divider />
    <div
      v-resize="onResize"
      class="position-sticky"
      style="top: 60px; overflow-y: auto"
      :style="{ maxHeight: maxHeight + 'px' }"
    >
      <slot />
    </div>
  </v-col>
</template>
<script>
export default {
  name: 'FiltersColumn',
  props: {
    title: {
      type: String,
      default: 'Apply Filters'
    },
    filtersActive: {
      type: Boolean,
      default: false
    },
    emphasized: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      maxHeight: window.innerHeight - 70
    }
  },
  methods: {
    onResize() {
      this.maxHeight = window.innerHeight - 70
    }
  }
}
</script>
